export default __webpack_public_path__ + "static/media/civ_humanitarian.648f0100.png";